import React from 'react'

import * as Yup from 'yup'
import { BasicForm } from '../../../../core/components/form'
import { usePostForm } from '../../../../hooks/manager/job'

import { useCacheManager, getManagersForSelect } from '../../../../hooks/cache/manager'
import { useCacheClient, getProjectsForSelect, getPointOfSalesByProjectForSelect, getComponentByPointOfSaleForSelect } from '../../../../hooks/cache/client'

import { useHistory } from 'react-router-dom'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'
import { LAYOUT_MANAGER_JOB_SHOW } from '../../navigation'
import { nowWithTimezone, getDateTimeApiFormat, getTimezone } from '../../../../core/utils/timezones'

import Form from './form'

const ValidationSchema = Yup.object().shape({
  eid: Yup.string().required('Project code cannot be blank.'),
  project: Yup.string().nullable().required('Project cannot be blank.'),
  name: Yup.string().required('Name cannot be blank.'),
  manager: Yup.string().nullable().required('Manager cannot be blank.'),
  client_deadline_at: Yup.date().required('Cannot be blank.').typeError('Must be a date'),
  received_at: Yup.date().required('Cannot be blank.').typeError('Must be a date')
})

const Formulario = () => {
  const create = usePostForm()
  const history = useHistory()

  const { data: managerData } = useCacheManager()
  const managers = getManagersForSelect(managerData)
  const { data: clientData } = useCacheClient()
  const projects = getProjectsForSelect(clientData)
  const pointOfSalesByProject = getPointOfSalesByProjectForSelect(clientData)
  const componentsByPointOfSale = getComponentByPointOfSaleForSelect(clientData)

  const onPressBack = () => history.goBack()

  function handleSubmit (values, bag) {
    const receivedAtTimezone = getTimezone(values.received_at);
    const receivedAt = getDateTimeApiFormat(values.received_at);

    const clientDeadlineAtTimezone = getTimezone(values.client_deadline_at);
    const clientDeadlineAt = getDateTimeApiFormat(values.client_deadline_at);

    const form = {
        ...values,
        client_deadline_at_timezone: clientDeadlineAtTimezone,
        client_deadline_at: clientDeadlineAt,
        received_at_timezone: receivedAtTimezone,
        received_at: receivedAt,
    }

    create.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        const { id } = data
        if (id) {
          return history.push(LAYOUT_MANAGER_JOB_SHOW(id))
        } else {
          onPressBack()
        }
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }


  const initialValues = {
    manager: '',
    project: '',
    point_of_sale: '',
    component: '',
    client_deadline_at: nowWithTimezone(),
    received_at: nowWithTimezone(),
    notes: '',
    code: '',
    name: '',
    /*lqa: [],*/
    eid: ''
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='ADD JOB'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={(formik) => (
        <Form 
          formik={formik} 
          projects={projects} 
          pointOfSalesByProject={pointOfSalesByProject} 
          componentsByPointOfSale={componentsByPointOfSale} 
          managers={managers} 
        />
      )}
    />
  )
}

export default Formulario
